import type { AgentUsageInput } from '@travel-planner/shared/schemas/agent-usage';
import { keepPreviousData } from '@tanstack/react-query';
import { trpc } from '@/shared/api/trpc';

export const useAiUsageReport = (input: AgentUsageInput) =>
  trpc.agentUsage.report.useQuery(input, {
    placeholderData: keepPreviousData,
  });

export const useExportAiUsageCsv = () =>
  trpc.agentUsage.exportCsv.useMutation();

export type AiUsageReport = NonNullable<
  ReturnType<typeof useAiUsageReport>['data']
>;
export type AiUsageSession = AiUsageReport['sessions'][number];
export type AiUsageItinerary = AiUsageReport['itineraries'][number];
export type AiUsageTool = AiUsageReport['byTool'][number];
export type AiUsageRole = AiUsageReport['byRole'][number];
export type AiUsageWeek = AiUsageReport['byWeek'][number];
export type AiUsagePerItinerary = NonNullable<
  AiUsageReport['summary']['averagePerItinerary']
>;
